module.exports = __webpack_public_path__ + "img/m-banner-tcawxgez-it-IT.d3ab8274.jpg";